import { usePathname, useSearchParams } from 'next/navigation'
import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { FILTER_ALL_SLUGS } from '@/legacy-src/components/filters/filters.constants'
import type { FilterSlug } from '@/legacy-src/components/filters/filters.interface'
import { VARIANT_IN_PARAMS_SLUG } from '@/legacy-src/lib/constants'

type Filter = { slug: FilterSlug | 'service'; value: string | string[] }

const removeExperimentFromParams = (params: URLSearchParams) => {
  // these are added to the url because of how the url is rewritten in middleware.ts
  params.delete('therapists')
  params.delete(VARIANT_IN_PARAMS_SLUG)
}

const removeAllFiltersFromParams = (params: URLSearchParams) => {
  FILTER_ALL_SLUGS.forEach((slug) => {
    params.delete(slug)
  })
}

export const useSetFilters = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  // This might cause problems in App Router, use window.history for shallow routing
  const router = useRouter()

  const setFilters = useCallback(
    (filters: Filter[], options: { fromScratch?: boolean; path?: string } = {}) => {
      const params = new URLSearchParams(searchParams === null ? '' : searchParams)

      removeExperimentFromParams(params)

      if (options.fromScratch) {
        removeAllFiltersFromParams(params)
      }

      filters.forEach((filter) => {
        {
          if (filter.value.length === 0) {
            params.delete(filter.slug)
          } else {
            if (Array.isArray(filter.value)) {
              params.set(filter.slug, filter.value.join(','))
            } else {
              params.set(filter.slug, filter.value)
            }
          }
        }
      })
      router.push((options.path ?? pathname) + '?' + params.toString(), undefined, { shallow: true })
    },
    [searchParams],
  )

  return setFilters
}
